import React, { useState } from 'react'
import { useParams } from 'react-router-dom';
import SingleLeagueAPI from '../components/Public/FootballAPI/League/SingleLeagueAPI'
import ViewJarallax from '../components/View/ViewJarallax'

function SingleLeagueAPIPage() {

    const {id} = useParams();

    const [league, setLeague] = useState();
    return (
        <div className="bg-light">
            <ViewJarallax 
                logo={league?.logo} 
                text={`${league?.country} ${league?.name} ${league?.season}`} 
                type="league" 
                id={id}
                league={league}
            />
            <div className="container">
                <SingleLeagueAPI league={league} setLeague={setLeague} />
            </div>
        </div>
    )
}
export default SingleLeagueAPIPage